import { useMap } from "react-map-gl/mapbox-legacy";
import { MapboxButtonMimic } from "./MapboxButtonMimic";

export const ZoomControl = () => {
  const { current: map } = useMap();

  return (
    <MapboxButtonMimic
      buttons={[
        {
          iconClass: "mapboxgl-ctrl-zoom-in",
          onClick: () => map?.zoomIn(),
          label: "Zoom in",
        },
        {
          iconClass: "mapboxgl-ctrl-zoom-out",
          onClick: () => map?.zoomOut(),
          label: "Zoom out",
        },
      ]}
    />
  );
};
